import React, { useEffect, useState, useRef } from 'react';
import { FaStore } from "react-icons/fa";
import { HiOutlinePhotograph } from "react-icons/hi";
import './StoreBanner.css';
import config from '../../../config';

const BannerDisplay = ({ imagePath, title, isWaitingForApi }) => {
    const [status, setStatus] = useState('loading');
    const imgRef = useRef(null);

    const cleanPath = imagePath && typeof imagePath === 'string' && imagePath.trim() !== '' && imagePath !== 'null' && imagePath !== 'undefined'
        ? imagePath.trim()
        : null;

    useEffect(() => {
        if (isWaitingForApi) {
            setStatus('loading');
            return;
        }

        if (!cleanPath) {
            setStatus('empty');
            return;
        }

        // بررسی اینکه اگر عکس از قبل در حافظه کش تلگرام لود شده است
        if (imgRef.current && imgRef.current.complete) {
            if (imgRef.current.naturalWidth > 0) {
                setStatus('loaded');
                return;
            }
        }

        setStatus('loading');
    }, [cleanPath, isWaitingForApi]);

    return (
        <div className="sb-display-wrapper">
            {/* اسکلتون تا زمان لود کامل تصویر فعال است */}
            {(isWaitingForApi || status === 'loading') && (
                <div className="sb-skeleton-shimmer sb-banner-skeleton"></div>
            )}

            {/* عکس همیشه در DOM قرار می‌گیرد تا ارتباط قطع نشود */}
            {cleanPath && (
                <img
                    ref={imgRef}
                    src={`${config.api.imageURL}/${cleanPath}`}
                    alt={title || "بنر فروشگاه"}
                    onLoad={() => setStatus('loaded')}
                    onError={() => setStatus('error')}
                    className={`sb-fade-image ${status === 'loaded' && !isWaitingForApi ? 'visible' : 'hidden'}`}
                />
            )}

            {/* فال‌بک متنی در صورت خالی بودن یا خطا */}
            {!isWaitingForApi && (status === 'empty' || status === 'error') && (
                <div className="sb-banner-empty sb-fade-in">
                    <HiOutlinePhotograph size={26} className="sb-empty-icon" />
                    <span className="sb-empty-text">محل نصب بنر فروشگاه</span>
                </div>
            )}
        </div>
    );
};

const LogoDisplay = ({ imagePath, title, isWaitingForApi }) => {
    const [status, setStatus] = useState('loading');
    const imgRef = useRef(null);

    const cleanPath = imagePath && typeof imagePath === 'string' && imagePath.trim() !== '' && imagePath !== 'null' && imagePath !== 'undefined'
        ? imagePath.trim()
        : null;

    useEffect(() => {
        if (isWaitingForApi) {
            setStatus('loading');
            return;
        }

        if (!cleanPath) {
            setStatus('empty');
            return;
        }

        // بررسی لود شدن آنی از کش در وب‌ویو تلگرام
        if (imgRef.current && imgRef.current.complete) {
            if (imgRef.current.naturalWidth > 0) {
                setStatus('loaded');
                return;
            }
        }

        setStatus('loading');
    }, [cleanPath, isWaitingForApi]);

    return (
        <div className="sb-display-wrapper">
            {(isWaitingForApi || status === 'loading') && (
                <div className="sb-skeleton-shimmer sb-logo-skeleton"></div>
            )}

            {cleanPath && (
                <img
                    ref={imgRef}
                    src={`${config.api.imageURL}/${cleanPath}`}
                    alt={title || "لوگو فروشگاه"}
                    onLoad={() => setStatus('loaded')}
                    onError={() => setStatus('error')}
                    className={`sb-fade-image ${status === 'loaded' && !isWaitingForApi ? 'visible' : 'hidden'}`}
                />
            )}

            {!isWaitingForApi && (status === 'empty' || status === 'error') && (
                <div className="sb-logo-empty sb-fade-in">
                    <FaStore size={18} className="sb-logo-empty-icon" />
                    <span className="sb-logo-empty-text">لوگو فروشگاه</span>
                </div>
            )}
        </div>
    );
};

const StoreBanner = ({ store, isScrolled, isLoading = false }) => {
    // مشخص‌کننده قطعی وضعیت لودینگ:
    // تا زمانی که یا isLoading هوک فعال است، یا فیلدهای اختصاصی API هنوز به store تزریق نشده‌اند
    const isWaitingForApi = Boolean(
        isLoading ||
        !store ||
        (store.image_banner === undefined && store.image_logo === undefined && store.theme_json === undefined)
    );

    return (
        <div className={`sb-banner-container ${isScrolled ? 'scrolled' : ''}`}>
            <div className="sb-banner-image">
                <BannerDisplay
                    imagePath={store?.image_banner}
                    title={store?.title}
                    isWaitingForApi={isWaitingForApi}
                />
            </div>
            <div className="sb-logo-container">
                <LogoDisplay
                    imagePath={store?.image_logo}
                    title={store?.title}
                    isWaitingForApi={isWaitingForApi}
                />
            </div>
        </div>
    );
};

export default StoreBanner;
